import React from 'react'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

type Props = {
  description?: string
  image: string
  meta?: { name: string; content: string }[]
  title: string
  type: 'article' | 'website'
  url: string
}

export default function SEO({ description, image, meta, title, type, url }: Props) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{ lang: 'ja' }}
      title={title}
      titleTemplate={'%s'}
      meta={[
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        { name: 'description', content: metaDescription },
        { property: 'og:description', content: metaDescription },
        { property: 'og:image', content: image },
        { property: 'og:site_name', content: site.siteMetadata.title },
        { property: 'og:title', content: title },
        { property: 'og:type', content: type },
        { property: 'og:url', content: url },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:creator', content: site.siteMetadata.author },
        { name: 'twitter:site', content: site.siteMetadata.author },
        { name: 'robots', content: process.env.GATSBY_ENV === 'production' ? 'all' : 'none' },
      ].concat(meta || [])}
    >
      <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
      <link rel="icon" href="https://award.mamari.jp/favicon.ico" />
    </Helmet>
  )
}
